module.exports = __webpack_public_path__ + "static/media/marker.ab5ffb79.svg";